import { Language } from "../types/locale";

export default (lang : Language) => {
    const copies = require('./' + lang + '.json');

    return {
        ...copies,
    }
}
